/* global wc_checkout_params */
document.addEventListener('alpine:init', () => {
	window.Alpine.data('couponForm', () => ({
		couponCode: '',
		open: false,
		error: null,

		submit() {
			if (
				!this.couponCode
				|| !wc_checkout_params.apply_coupon_nonce
				|| !wc_checkout_params.wc_ajax_url
				|| !jQuery
			) {
				return
			}

			this.error = null

			fetch(
				wc_checkout_params.wc_ajax_url
					.toString()
					.replace('%%endpoint%%', 'apply_coupon'),
				{
					method: 'POST',
					headers: {
						'Content-Type': 'application/x-www-form-urlencoded',
					},
					body: new URLSearchParams({
						coupon_code: this.couponCode,
						security: wc_checkout_params.apply_coupon_nonce,
					}),
				},
			)
				.then((response) => response.text())
				.then((data) => {
					if (
						data.includes('woocommerce-error')
						|| data.includes('is-error')
					) {
						this.error = data.replace(/<[^>]*>/g, '').trim()
						this.couponCode = ''

						return
					}

					jQuery(document.body).trigger('applied_coupon_in_checkout', [
						this.couponCode,
					])
					jQuery(document.body).trigger('update_checkout', {
						update_shipping_method: false,
					})

					this.couponCode = ''
					this.open = false
				})
				.catch(() => {})
		},
	}))
})
